var Country = /** @class */ (function () {
    function Country() {
    }
    /**
     * Only USA has states for now.
     */
    Country.prototype.hasStates = function () {
        var _a, _b;
        //return this.countryCode === "US";
        return ((_b = (_a = this.states) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    };
    Country.createFromApi = function (dto) {
        return Object.assign(new Country(), dto, {
            states: []
        });
    };
    return Country;
}());
export { Country };
